function updateQuantity(line,quantity) {
  $.ajax({
      type: 'POST',
      url: '/cart/change',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      success: function(cart) {
      },
    });
}

$(document).ready(function() {
  $('.cv--atc').click(function(e){
    e.preventDefault();
    var data = $(this).parents('form').serialize();
    var qty = 1;
    $.ajax({
      type: 'POST',
      url: '/cart/add',
      data: data,
      dataType: 'html',
      success: function(response){
        $('.cart__drawer-item').html($(response).find('.cart__drawer-item').html());
        $('.cart__drawer').html($(response).filter('.cart__drawer').html()).addClass('show-cart__drawer');
        $('.cart__drawer').addClass('show-cart__drawer');
        $('body').addClass('cv--show-cart__drawer');
        $('.cross').click(function(){
          $('.cart__drawer').removeClass('show-cart__drawer');
        });
      }
    });

  });
});



  $(document).on("click",".o-main-header .o-main-header__cart--link", function(e) {
    e.preventDefault();
     e.stopPropagation();
    $('.cart__drawer').addClass('show-cart__drawer');
    $('body').addClass('cv--show-cart__drawer');
    console.log('codevibez');
  });
  $(document).on("click",".heading-text .cross",function() {
    $('.cart__drawer').removeClass('show-cart__drawer');
    $('body').removeClass('cv--show-cart__drawer');
  });
  $(document).mouseup(function(e){
    var container = $(".cart__drawer");
    if (!container.is(e.target) && container.has(e.target).length === 0){
      container.show();
      $('.cart__drawer').removeClass('show-cart__drawer');
      $('body').removeClass('cv--show-cart__drawer');
    }
  });
  $(document).on('click','.cart_note .order_notes label', function(){
    if($(this).parent().hasClass('open_order_note')){
    $(this).parent().removeClass('open_order_note');
    }else{
        $(this).parent().addClass('open_order_note');
    }
});


$(document).ready(function() {
  $(document).on("click",".cart__remove",function(e) {
    e.preventDefault();
    let $btn = $(this);
    $btn.contents().filter(function() {
      return this.nodeType === 3; // text node
    }).remove();
    $btn.find(".cart-loader-svg").css('opacity', '1');
    var itemUrl = $(this).attr('href');
    $.ajax({
      url: itemUrl,
      type:'GET',
      dataType: 'html',
      success: function(response){
        $('.cart__drawer-center').html($(response).find('.cart__drawer-center').html());
        $('span[data-cart-counter]').html($(response).find('span[data-cart-counter]').html())
        window.initExtendedWarranty();
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
        multiplyLinePrice()
        updatedDiscount();
        cartFooterHeight();
        

        // yahan se same condition check karo
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            if (cart.items.length === 1) {
              let item = cart.items[0];
              if (item.properties && item.properties["Gift Wrap"] === "Yes") {
                // agar sirf 1 item hai aur Gift Wrap: Yes hai -> remove kar do
                $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  data: { id: item.key, quantity: 0 },
                  dataType: 'json',
                  success: function(updatedCart){
                    // cart ko refresh karo
                    fetch('/cart')
                      .then(r => r.text())
                      .then(html => {
                        $('.cart__drawer-center').html($(html).find('.cart__drawer-center').html());
                        $('span[data-cart-counter]').html($(response).find('span[data-cart-counter]').html())
                        window.initExtendedWarranty();
                        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
                        multiplyLinePrice()
                        updatedDiscount()
                        cartFooterHeight();
                      });
                  }
                });
              }
            }
          });
      }
    });
  });
});



$(document).ready(function() {

  $(document).on("click",".plus",function() {
    var bttn = $(this);
    let $btn = $(this).parents('.cart-items_title_btn').find('span.final-price');
    $btn.contents().filter(function() {
      if (this.nodeType === 3) {
        return true;
      }
      if (this.nodeType === 1 && this.nodeName.toLowerCase() === 'span') {
        return true;
      }
      return false;
    }).remove();
    $btn.parents('.cart-items_title_btn').find(".cart-loader-svg-price").css('opacity', '1');


    $(this).prev().val(+$(this).prev().val() + 1);
    var data =  $(this).parents('form').serialize();
    console.log(data);
    var quantity = $(this).prev().val();
    updateQuantity(data,quantity);
    $.ajax({
      type: 'POST',
      url: '/cart/update',
      data: data,
      dataType: 'html',
      success: function(response){
        $('.cart__drawer-center').html($(response).find('.cart__drawer-center').html());
        $('span[data-cart-counter]').html($(response).find('span[data-cart-counter]').text())
        window.initExtendedWarranty();
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
        
        multiplyLinePrice();
        updatedDiscount()
        cartFooterHeight();
      }
    });

  });

$(document).on("click",".minus",function() { 
  var bttn = $(this)
  let $btn = $(this).parents('.cart-items_title_btn').find('span.final-price');
  $btn.contents().filter(function() {
    if (this.nodeType === 3) {
      return true;
    }
    if (this.nodeType === 1 && this.nodeName.toLowerCase() === 'span') {
      return true;
    }
    return false;
  }).remove();
  $btn.parents('.cart-items_title_btn').find(".cart-loader-svg-price").css('opacity', '1');

  if ($(this).next().val() > 0) {
    $(this).next().val(+$(this).next().val() - 1);
    var data =  $(this).parents('form').serialize();
    var quantity = $(this).next().val();
    updateQuantity(data,quantity);

    $.ajax({
      type: 'POST',
      url: '/cart/update',
      data: data,
      dataType: 'html',
      success: function(response){
        $('.cart__drawer-center').html($(response).find('.cart__drawer-center').html());
        $('span[data-cart-counter]').html($(response).find('span[data-cart-counter]').html())
        window.initExtendedWarranty();
        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
        multiplyLinePrice();
        updatedDiscount()
        cartFooterHeight();

        // yahan se check karna hai
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            if (cart.items.length === 1) {
              let item = cart.items[0];
              if (item.properties && item.properties["Gift Wrap"] === "Yes") {
                // agar sirf 1 item bachi hai aur vo gift wrap hai to remove kar do
                $.ajax({
                  type: 'POST',
                  url: '/cart/change.js',
                  data: { id: item.key, quantity: 0 },
                  dataType: 'json',
                  success: function(updatedCart){
                    // cart ko dobara refresh kar lo
                    fetch('/cart')
                      .then(r => r.text())
                      .then(html => {
                        $('.cart__drawer-center').html($(html).find('.cart__drawer-center').html());
                        $('span[data-cart-counter]').html($(response).find('span[data-cart-counter]').html())
                        window.initExtendedWarranty();
                        BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
                        multiplyLinePrice()
                        updatedDiscount()
                        cartFooterHeight();
                      });
                  }
                });
              }
            }
          });
      }
    });
  }
});

});

window.initExtendedWarranty = async function initExtendedWarranty() {
  const checkbox = document.getElementById("extended-warranty");
  if (!checkbox) return;

  let variantId = checkbox.getAttribute("data-id");

  let cart = await fetch("/cart.js").then(res => res.json());
  let found = cart.items.some(item => item.variant_id == variantId);
  checkbox.checked = found;

  checkbox.onchange = async function () {
    if (checkbox.checked) {
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: variantId,
          quantity: 1,
          properties: { "Gift Wrap": "Yes" }
        })
      });
      await refreshCartDrawer();
    } else {
      let cartNow = await fetch("/cart.js").then(r => r.json());
      let item = cartNow.items.find(i => i.variant_id == variantId);
      if (item) {
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
        await refreshCartDrawer();
      }
    }
  };
};

async function refreshCartDrawer() {
  let response = await fetch("/cart");
  let html = await response.text();

  $(".cart__drawer-center").html(
    $(html).find(".cart__drawer-center").html()
  );

  if (typeof window.initExtendedWarranty === "function") {
    window.initExtendedWarranty();
  }
  BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
  multiplyLinePrice()
  updatedDiscount()
  cartFooterHeight();
}

window.initExtendedWarranty();

const target = document.querySelector('.o-main-header__cart--link-span[data-cart-counter]');
if (target) {
  

  const observer = new MutationObserver(function(mutationsList) {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'characterData') {
        target.closest('.o-main-header__cart--link').setAttribute('disabled','true');
        fetch(window.location.href)
          .then(r => r.text())
          .then(html => {
            // Check if classes are already applied
            const bodyHasClass = $('body').hasClass('cv--show-cart__drawer');
            const drawerHasClass = $('.cart__drawer').hasClass('show-cart__drawer');

            if (!(bodyHasClass && drawerHasClass)) {
              $('.cart__drawer-center').html($(html).find('.cart__drawer-center').html());
              $('body').addClass('cv--show-cart__drawer');
              $('.cart__drawer').addClass('show-cart__drawer');

              window.initExtendedWarranty();
              BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
              multiplyLinePrice()
              updatedDiscount();
              cartFooterHeight();
                setTimeout(function(){
                  target.closest('.o-main-header__cart--link').removeAttribute('disabled');
                },2000)
            } else{
              setTimeout(function(){
                  target.closest('.o-main-header__cart--link').removeAttribute('disabled');
                },2000)
            }
          });
      }
    }
  });
  observer.observe(target, {
    childList: true,
    characterData: true,
    subtree: true
  });
}




  $(document).on('click','.cdrawer-chekout-btn', function(e){
    e.preventDefault();
    e.stopPropagation();
    $('.cart__drawer-form').submit();
    window.location.href = "/checkout";
  })

function checkAndRemoveGiftWrap() {
  // Agar wrap_products hai to kuch nahi karna
  if ($('.cart__drawer .wrap_products').length > 0) {
    return;
  }

  // warna cart check karo
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      cart.items.forEach(item => {
        if (item.properties && item.properties["Gift Wrap"] === "Yes") {
          // gift wrap remove kar do
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            data: { id: item.key, quantity: 0 },
            dataType: 'json',
            success: function(updatedCart){
              // cart dobara refresh karo
              fetch('/cart')
                .then(r => r.text())
                .then(html => {
                  $('.cart__drawer-center').html($(html).find('.cart__drawer-center').html());
                  $('span[data-cart-counter]').html($(response).find('span[data-cart-counter]').text())
                  window.initExtendedWarranty();
                  BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
                  multiplyLinePrice()
                  updatedDiscount()
                  cartFooterHeight();
                });
            }
          });
        }
      });
    });
}

// page load hone ke baad call karo
$(document).ready(function() {
  checkAndRemoveGiftWrap();
  updatedDiscount();
  cartFooterHeight();
  multiplyLinePrice();
  updatedDiscount();
});

function updatedDiscount(){
  function calcccc() {
    var totalsub = 0;
    var totalCompare = 0;
    $('.final-price .compare-at-price').each(function(index){
        totalCompare += parseInt($(this).html().replace(/[^0-9]/g, ''), 10);
        totalsub += parseInt($(this).siblings('.finals_prices').html().replace(/[^0-9]/g, ''), 10);
    });
  
    let discnt = totalCompare - totalsub;
    let dollars = discnt / 100;
    let currency = Shopify.currency.active;
    let formatted = new Intl.NumberFormat(undefined, { 
      style: 'currency', 
      currency: currency,
      currencyDisplay: 'narrowSymbol'
    }).format(dollars);
    $('.subtotal_price_discount').html(formatted)
    setTimeout(function(){
      $('.subtotal_price_discount').show();
      
    },1200)
  } 
  calcccc();
  let i = setInterval(calcccc,1000);
  setTimeout(()=>clearInterval(i),5000);
}

function cartFooterHeight() {
  var cartHeight = $('.cart_drawer_footer').outerHeight() + 78.98; 
  $('.cart__drawer-form').css('height', 'calc(100vh - ' + cartHeight + 'px)');
}
$(window).on('resize', function () {
  cartFooterHeight();
});

// function multiplyLinePrice(){
//   function calc() {
//     priceToPrice();
//     $('.cart_items').each(function(){
//       var itemPrice = parseInt($(this).find('.finals_prices').html().replace(/[^0-9]/g, ''), 10)
//       var qtySelector = parseInt($(this).find('.item-qty').val())
//       var resultt = itemPrice * qtySelector;
//       let dollars = resultt / 100;
//       let currency = Shopify.currency.active;
//       let formatted = new Intl.NumberFormat(undefined, { 
//           style: 'currency', 
//           currency: currency,
//           currencyDisplay: 'narrowSymbol'
//       }).format(dollars);
//       $(this).find('.finals_prices').html(formatted);
//       setTimeout(function(){
//         $('span.finals_prices').show();
        
//         var pr_pric_total = 0;
//         $('.final-price .finals_prices').each(function(index){ 
//             var pr_price1 = parseInt($(this).text().replace(/[^0-9]/g, ""));
//              pr_pric_total += pr_price1;
//             console.log('pr_price1',pr_pric_total);
//         });
//       },1200)
//     })
//   } 
//   calc();
//   let i = setInterval(calc,1000);
//   setTimeout(()=>clearInterval(i),5000);
// }

function multiplyLinePrice(){
  function calc() {
    priceToPrice();
    $('.cart_items').each(function(){
      var itemPrice = parseInt($(this).find('.finals_prices').html().replace(/[^0-9]/g, ''), 10);
      var qtySelector = parseInt($(this).find('.item-qty').val());
      var resultt = itemPrice * qtySelector;

      let dollars = resultt / 100;
      let currency = Shopify.currency.active;
      let formatted = new Intl.NumberFormat(undefined, { 
          style: 'currency', 
          currency: currency,
          currencyDisplay: 'narrowSymbol'
      }).format(dollars);

      $(this).find('.finals_prices').html(formatted);
    });

    setTimeout(function(){
      $('span.finals_prices').show();

      var pr_pric_total = 0;
      $('.final-price .finals_prices').each(function(index){ 
          var pr_price1 = parseInt($(this).text().replace(/[^0-9]/g, ""));
          pr_pric_total += pr_price1;
      });
      var veryfinalprice = pr_pric_total / 100;
      let currency1 = Shopify.currency.active;
      let formatted1 = new Intl.NumberFormat(undefined, { 
          style: 'currency', 
          currency: currency1,
          currencyDisplay: 'narrowSymbol'
      }).format(veryfinalprice);
      $('.subtotal_price').text(formatted1);
    }, 1200);
  } 

  calc();
  let i = setInterval(calc,1000);
  setTimeout(()=>clearInterval(i),5000);
}


function priceToPrice(){
  $('.final-price').each(function(){
    if ($(this).find('.money').length > 0) {
      var priceee = $(this).find('.money').html();
    } else if ($(this).find('.lineitemmoney').length > 0) {
      var priceee = $(this).find('.lineitemmoney').html();
    }
    $(this).find('.finals_prices').html(priceee)
  })
  // $('.subtotal_price').html($('.cart__drawer-bottom .subtotal_price');
}